import Table from './Table';
export default Table;

export { default as TableHead } from './TableHead';
export { default as TableBody } from './TableBody';
export { default as TableDividerRow } from './TableDividerRow';

export { default as TableBodyWithLoadingPlaceholder } from './TableBodyWithLoadingPlaceholder';
